import React from "react";
import PropTypes from "prop-types";
import { getHotelURL } from "../../utils/gatsby-helpers";
import { RCL as useTranslation } from "../../components/RCL";
import { CardsContainerGrid } from "../../components/CardsContainer";
import { CardConnector } from "../CardConnector";
import { extractTransformationAndPublicIdSegment } from "../../components/Hotels/utils/extractTransformationAndPublicIDSegment";

const DestinationTilesConnector = ({ hotels, locale }) => {
	let lang = "en";

	if (locale === "fr-CA") {
		lang = "fr";
	}

	const translations = {
		loadAll: useTranslation({ searchKey: "load-all" }),
		loadMore: useTranslation({ searchKey: "load-more" }),
		exploreMoreLabel: useTranslation({ searchKey: "explore-more" }),
	};

	const parsedHotels = hotels.map(hotelData => {
		const hotel = hotelData.node.data;
		const images = hotel.HotelImages.images?.map((img, index) => {
			const { publicId, baseUrl } = extractTransformationAndPublicIdSegment(img?.src);
			return {
				alt: "",
				id: index,
				public_id: publicId,
				baseUrl,
			};
		});

		return {
			sys: {
				contentType: {
					sys: {
						id: "card",
					},
				},
			},
			id: hotel.contentful_id,
			iconName: "chevron-right",
			variant: "Hotel Default",
			heading: `${hotel.DestinationName}, ${hotel.RegionName}`,
			subheading: hotel.HotelName,
			stars: parseFloat(hotel.StarRating, 2),
			labels: {
				allInc: hotel.MealPlanFeatures?.MealPlan?.[0].Name,
			},
			hotelCode: hotel.HotelCode,
			image: images,
			link: {
				url: getHotelURL(lang, hotel.RegionName, hotel.DestinationName, hotel.HotelName),
				linkText: translations.exploreMoreLabel,
			},
		};
	});

	return (
		<CardsContainerGrid
			numberToShow={6}
			labels={{
				loadAll: translations.loadAll,
				loadMore: translations.loadMore,
			}}>
			{parsedHotels.map(item => (
				<CardConnector key={item.id} data={item} />
			))}
		</CardsContainerGrid>
	);
};

DestinationTilesConnector.propTypes = {
	hotels: PropTypes.arrayOf(PropTypes.shape()),
	locale: PropTypes.string,
};

DestinationTilesConnector.defaultProps = {
	hotels: [],
	locale: "en-CA",
};

export { DestinationTilesConnector };
